import { APPACCESSTOKEN } from '../utils/const';
import { appOpenUrl, isApp, isWxMiniProgram } from '../utils/api';

/**fetchUserWebWxBoundCheck**/
export const fetchUserWebWxBoundCheck = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_webwxboundcheck',
		body: {
			wxuserinfo: obj.wxuserinfo || ''
		},
		success: res => {
			obj.success && obj.success(res);
		}
	});
};

/**
 * fetchSubscription 订阅
 * @param: (String) contentid id
 * @param: (String) contenttype 类型 ('6':股票 '7':专题)
 * @param: (String) operate 订阅/取消订阅 ('1':添加关注，'0':取消关注)
 * **/
export const fetchSubscription = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_subscription_operate',
		access: APPACCESSTOKEN,
		body: {
			contentid: obj.contentid,
			contenttype: obj.contenttype,
			operate: obj.operate,
			topictype: obj.topictype
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/**
 * fetchTopicList 请求专题列表
 * @param: (String) topicid 专题id
 * @param: (String) pagestart 起始页
 * @param: (String) pagenum 每页显示数量
 * **/
export const fetchTopicList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_topicontent',
		body: {
			topicid: obj.topicid,
			// status: obj.status,
			pagestart: obj.pagestart,
			pagenum: obj.pagenum,
			keyword: obj.keyword || '',
			roadshowStatus: obj.roadshowStatus,
			industryTagIds: obj.industryTagIds || '',
			roadshowInterval: obj.roadshowInterval || '',
			dates: obj.dates || ''
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: obj.loading || false
	});
};

/**fetchUserDetail 请求用户信息
 * @param: (String) userUid 不传默认获取当前用户
 * **/
export const fetchUserDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_userdetail',
		code_201: obj.code_201 || false,
		body: {
			userUid: obj.userUid || ''
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', {
					msg: desc
				});
			}
		},
		loading: obj.loading
	});
};

// 网页第三方渠道用户登录
/**
 * @param ctx
 * @param obj channel(必填) -> uc(用户渠道)
 * info(必填) -> userinfo(用户信息)
 * success()
 * **/
export const fetchWebChannelLogin = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_webchannellogin',
		body: {
			uc: obj.channel,
			userinfo: obj.info || '',
			extrauserinfo: obj.extrauserinfo || ''
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code, desc);
		}
	});
};

/** fetchLoginByPwd 密码登录
 * @param: (String) password
 * @param: (String) username
 * **/
export const fetchLoginByPwd = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_weblogin',
		body: {
			password: obj.password,
			username: obj.username
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				if (Number(code) == 10411 || Number(code) == 10412) {
					ctx.dispatch('showDialog', {
						dialog_alert: true,
						dialog_text:
							Number(code) == 10411
								? desc
								: '密码错误次数过多，请半小时过后登录，可选择手机验证码登录，或登录手机APP找回密码',
						dialog_alert_data: [
							{
								btn: '确定',
								callback: ctx.dispatch('hideDialog')
							}
						]
					});
				} else {
					ctx.dispatch('showTooltip', {
						msg: desc
					});
				}
			}
		},
		loading: true
	});
};

/** fetchLoginByPhone 手机号登录
 * @param: (String) phone 手机号码
 * @param: (String) authcode 验证码
 * @param: (String) areacode 区号
 * @param: (String) boundwx 是否绑定微信
 * **/
export const fetchLoginByPhone = (ctx, obj) => {
	let body = {
		phone: obj.phone,
		authcode: obj.authcode,
		areacode: obj.areacode,
		boundwx: obj.boundwx
	};
	// obj.agreeprovision && (body.agreeprovision = obj.agreeprovision);
	// obj.wxuserinfo && (body.wxuserinfo = obj.wxuserinfo);
	comeinFetch({
		constant_key: 'json_user_phonelogin',
		body,
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', {
					msg: desc
				});
			}
		},
		loading: true
	});
};

/**fetchPhoneAuth 获取手机验证码
 * @param: (String) phone 手机号码
 * @param: (String) areacode 区号
 * **/
export const fetchPhoneAuth = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_getphoneauth',
		body: {
			phone: obj.phone,
			areacode: obj.areacode,
			cmdtype: obj.cmdtype,
			ticket: obj.ticket,
			randStr: obj.randStr
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code, desc);
			if (!obj.hideTooltip) {
				ctx.dispatch('showTooltip', { msg: desc });
			}
		},
		loading: true
	});
};

/**fetchPhoneAuthV2 判断手机是否已经被绑定
 * @param: (String) phone 手机号码
 * @param: (String) areacode 区号
 * **/
export const fetchPhoneAuthV2 = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_clever-bind-phone-v2',
		body: {
			phone: obj.phone,
			areaCode: obj.areacode
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code);
			// if(code!=1960){
			ctx.dispatch('showTooltip', { msg: desc });
			// }
		},
		loading: true
	});
};

/**fetchEmailAuth 换绑/绑定邮箱
 * @param: (String) email 新邮箱地址
 * @param: (String) code 验证码
 * 注：如果没传code则表示获取验证码
 * **/
export const fetchEmailAuth = (ctx, obj) => {
	let body = {};
	if (obj.email) {
		body.email = obj.email;
	}
	if (obj.code) {
		body.code = obj.code;
	}
	if (obj.agreeprovision) {
		body.agreeprovision = obj.agreeprovision;
	}
	comeinFetch({
		constant_key: 'json_account_change-email',
		body: body,
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', { msg: desc });
			}
		},
		loading: true
	});
};

/**fetchGetEmailCode 获取邮箱验证码
 * @param: (String) email 邮箱，默认为当前登录用户邮箱
 * @param: (String) cmdtype 场景：
 * 	withdrawboundwx： 绑余额提现的微信账户获取手机验证码
 * 	resetpaypwd： 重置支付密码时获取手机验证码
 * 	changeemail： 换绑邮箱
 * @param: (String) uid 用户ID， 已登录用户需要
 * **/
export const fetchGetEmailCode = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_getemailauth',
		body: {
			email: obj.email,
			cmdtype: obj.cmdtype
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code);
			ctx.dispatch('showTooltip', { msg: desc });
		},
		loading: true
	});
};

/**fetchVerifEmailCode 验证邮箱验证码
 * @param: (String) email 邮箱，默认为当前登录用户邮箱
 * @param: (String) cmdtype 场景：
 * 	withdrawboundwx： 绑余额提现的微信账户获取手机验证码
 * 	resetpaypwd： 重置支付密码时获取手机验证码
 * 	changeemail： changeemail
 * @param: (String) authcode 手机验证码
 * @param: (String) uid 用户ID， 已登录用户需要
 * **/
export const fetchVerifEmailCode = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_checkemailauth',
		body: {
			email: obj.email,
			cmdtype: obj.cmdtype,
			authcode: obj.authcode
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code);
			ctx.dispatch('showTooltip', { msg: desc });
		},
		loading: true
	});
};

/**fetchCheckPhoneAuth 验证手机验证码
 * @param: (String) phone 手机号码
 * @param: (String) authcode 验证码
 * @param: (String) cmdtype 场景
 * **/
export const fetchCheckPhoneAuth = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_checkphoneauth',
		body: {
			phone: obj.phone,
			authcode: obj.authcode,
			cmdtype: obj.cmdtype
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code);
			ctx.dispatch('showTooltip', { msg: desc });
		},
		loading: true
	});
};

/**fetchCleverBindPhone 首次绑定手机号
 * @param: (String) phone 手机号码
 * @param: (String) authcode 验证码
 * @param: (String) agreeprovision 是否将微信号绑定到此账号下
 * **/
export const fetchCleverBindPhone = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_cleverbindphone',
		body: {
			phone: obj.phone,
			authcode: obj.authcode,
			agreeprovision: obj.agreeprovision
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', { msg: desc });
			}
		},
		loading: true
	});
};

/**fetchChangePhone 换绑手机号
 * @param: (String) newphone 新手机号码
 * @param: (String) authcode 验证码
 * @param: (String) areacode 区号
 * **/
export const fetchChangePhone = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_changephone',
		body: {
			newphone: obj.phone,
			authcode: obj.authcode,
			areacode: obj.areacode
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code);
			ctx.dispatch('showTooltip', { msg: desc });
		},
		loading: true
	});
};

/**fetchUserBound 绑定**/
export const fetchUserBound = (ctx, obj) => {
	let body = {};
	if (obj.cmdtype === 'boundphone') {
		body = {
			cmdtype: obj.cmdtype,
			phone: obj.phone,
			verifycode: obj.verifycode
		};
		obj.areaCode && (body.areaCode = obj.areaCode);
		obj.agreeprovision && (body.agreeprovision = obj.agreeprovision);
	} else if (obj.cmdtype === 'boundthird') {
		body = {
			cmdtype: obj.cmdtype,
			phone: obj.name,
			openid: obj.openid,
			thirdtype: obj.thirdtype
		};
	}
	comeinFetch({
		constant_key: 'json_user_bound',
		body,
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', {
					msg: desc
				});
			}
		},
		loading: true
	});
};

/**fetchChangePwd 修改密码
 * @param: (String) newpwd 新密码
 * @param: (String) oldpw 旧密码（必选：否）
 * @param: (String) authcode 验证码
 * **/
export const fetchChangePwd = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_updatepassword',
		body: {
			newpw: obj.newpwd,
			// oldpw: obj.oldpwd || "",
			b: '3.5.6',
			authcode: obj.authcode
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code, desc);
			ctx.dispatch('showTooltip', { msg: desc });
		},
		loading: true
	});
};

/**fetchEmailCheck 中信邮箱登录和注册
 * @param:(String) email 邮箱地址
 * @param:(String) authcode 验证码，空值为发送验证码，非空为校验并注册
 * **/
export const fetchEmailLogin = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_emaillogin',
		body: {
			email: obj.email,
			authcode: obj.authcode, //验证码，空值为发送验证码，非空为校验并注册
			type: obj.type,
			ticket: obj.ticket,
			randStr: obj.randStr
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code);
			ctx.dispatch('showTooltip', { msg: desc });
		}
		// loading: true
	});
};

/**fetchEmailCheck 组织邮箱验证和注册
 * @param:(String) bannerid 栏目id
 * @param:(Obj) optional 可选参数
 * **/
export const fetchCheckEmail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_organization_emailregist',
		body: {
			organizationId: obj.organizationId,
			email: obj.email,
			isContinue: obj.isContinue,
			code: obj.code //验证码，空值为发送验证码，非空为校验并注册
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (code === '1986') {
				obj.error(code);
			} else {
				ctx.dispatch('showTooltip', {
					msg: desc
				});
			}
		},
		loading: true
	});
};

/**fetchEmailZXCheck 校验邮箱是否在中信CRM系统
 * @param:(String) bannerid 栏目id
 * @param:(Obj) optional 可选参数
 * **/
export const fetchCheckEmailZX = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_check_email-zx',
		body: {
			email: obj.email
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code);
			// ctx.dispatch("showTooltip", {msg: desc})
		},
		loading: true
	});
};

// 预约路演 status状态：0=取消预约，1=预约
export const fetchRoadshowAppointment = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_appointment',
		body: {
			roadshowId: Number(obj.roadshowId),
			status: obj.status || 0
		},
		success: res => {
			obj.success && obj.success(res);
		}
	});
};
